import { useCallback, useState } from 'react';

import { AcceptCookies } from 'components/AcceptCookies';
import { useMainDispatch } from 'modules/main/store';
import { updateUserEnvironmentEnvironment } from 'modules/main/store/ducks/userEnvironment';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';
import { post } from 'utils/http';

export function AcceptCookiesContainer() {
  const [submitting, setSubmitting] = useState(false);

  const { isUserLoaded, isEnvironmentLoaded, environment } =
    useUserEnvironment();
  const dispatch = useMainDispatch();

  const acceptCookies = useCallback(async () => {
    if (!isUserLoaded || !isEnvironmentLoaded) return;

    setSubmitting(true);

    await post('/data/website/accept-cookies', {});
    dispatch(
      // @ts-expect-error TS(2345): Argument of type '{ showAcceptCookies: false; gues... Remove this comment to see the full error message
      updateUserEnvironmentEnvironment({
        ...environment,
        showAcceptCookies: false,
      })
    );
    setSubmitting(false);
  }, [isUserLoaded, isEnvironmentLoaded, environment, dispatch]);

  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  if (!isEnvironmentLoaded || !environment.showAcceptCookies) return null;
  return (
    <AcceptCookies onAcceptCookies={acceptCookies} submitting={submitting} />
  );
}
